module.exports = __webpack_public_path__ + "img/quest_icon_0026_attack.a5b560fc.png";